import { Box, Button, Center, type ColorProps, Heading, Stack, Text } from '@chakra-ui/react'
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { getOnboardingUrl } from '@/client/services/url'

import LoginButton from '@/components/Buttons/LoginButton'
import ShwLink from '@/components/ShwLink'
import ShwLogo from '@/components/UI/ShwLogo'

const RestrictedPageAccess: React.FC<{
  title: string
  faIcon?: IconDefinition | null
  iconColor?: ColorProps['color']
  hideHomeButton?: boolean
  hideLoginButton?: boolean
  showOnboardingButton?: boolean
  description?: string | JSX.Element
  loginButtonProps?: React.ComponentProps<typeof LoginButton>
  alignCenter?: boolean
}> = ({
  title,
  faIcon = null,
  iconColor = 'primary.fg',
  hideHomeButton = false,
  hideLoginButton = false,
  showOnboardingButton = false,
  description = '',
  loginButtonProps,
  alignCenter = false,
}) => (
  <Center p="16px" height="100%" width="100%" overflowY="auto">
    <Stack direction="column" align="center" spacing="32px">
      <Box>
        {faIcon == null ? (
          <ShwLogo height="100px" />
        ) : (
          <Text color={iconColor} fontSize="96px">
            <FontAwesomeIcon icon={faIcon} />
          </Text>
        )}
      </Box>
      <Heading as="h2" size="2xl" textAlign={alignCenter ? 'left' : 'center'}>
        {title}
      </Heading>
      <Box maxW="700px">{description}</Box>
      <Stack direction="row" spacing="16px">
        {hideHomeButton ? null : (
          <ShwLink href="/">
            <Button>Return Home</Button>
          </ShwLink>
        )}
        {showOnboardingButton ? (
          <ShwLink href={getOnboardingUrl()}>
            <Button maxWidth="220px">Return to Onboarding</Button>
          </ShwLink>
        ) : null}
        {hideLoginButton ? null : <LoginButton {...loginButtonProps} />}
      </Stack>
    </Stack>
  </Center>
)

export default RestrictedPageAccess
